import { createContext } from "react";

export type LoadingContextType = {
	showLoadingScreenCallback: () => void;
	hideLoadingScreenCallback: () => void;
};

export const ShowLoadingScreenToUserContext = createContext<LoadingContextType>({} as unknown as LoadingContextType);
